<template>
  <div>
    <logged-in-header />
    <simulador />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import simulador from "../components/ferramentas/Simulador.vue";

export default {
  components: {
    loggedInHeader,
    simulador
  }
};
</script>
